import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {mbeConfigService} from './mbe-config.service';
import { NotificationsInterface} from '../..';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  private URL;
  headers: HttpHeaders;

  constructor(@Inject(mbeConfigService) private config, private httpClient: HttpClient) {
    this.URL = config.REST_SERVER_HOST + config.REST_SERVER_url.find(restUrl => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllNotifications(): Observable<NotificationsInterface[]> {
    const headers = this.headers;
    return this.httpClient.get<NotificationsInterface[]>(`${this.URL}/not/allnotifications`, {headers});
  }

  getNotification(id: number) {
    console.log(`ID: ${id}`);
    const headers = this.headers;
    return this.httpClient.get<NotificationsInterface>(`${this.URL}/not/getnotification/${id}`, {headers});
  }
}
